// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_20fU2UNeGLtKYcOMGVYNaR","content":"_76JuVQmdF7RFjMCZimAli"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Page404/Page404.mod.css
// module id = 1644
// module chunks = 0